export class Flavor {
    ID?: number;
    Code?: string;
    Name?: string;
    FullName?: string;
    Inactive: boolean;
    FountainAvailable?: boolean;
}

export default Flavor;